module.exports = __webpack_public_path__ + "media/images/boxes-holiday-15ff53e59dbcbaeed565949d04cf648e.svg";